import get from 'lodash/get'
import Store from '~/store'
import Router from '~/router'
import AuthService from 'services/AuthService'

function loadAndComposeData(promises) {
    const names = Object.keys(promises)

    return Promise.all(Object.values(promises)).then((responses) =>
        responses.reduce((data, response, index) => {
            data[names[index]] = response
            return data
        }, {}),
    )
}

function setDataInPage(page, data) {
    return Object.assign(page, data)
}

function resetUiState() {
    Store.dispatch('ui/switchOffShowingErrorPages')
    Store.dispatch('ui/hidePageLoader')
}

function beforeRoute(to, from, next, page) {
    Store.dispatch('ui/showPageLoader')

    const matchedRoute = to.matched[to.matched.length - 1]
    const methods = get(matchedRoute, 'components.default.methods')
    const loadData = get(matchedRoute, 'components.default.loadData', () => Promise.resolve())

    loadAndComposeData(
        loadData({
            ...methods,
            $store: Store,
            $router: Router,
            $route: to,
            $auth: AuthService,
        }),
    )
        .then((data) => {
            if (page) {
                setDataInPage(page, data)
                resetUiState()
                next()
            } else {
                next((page) => {
                    setDataInPage(page, data)
                    resetUiState()
                })
            }
        })
        .catch((error) => {
            switch (get(error, 'response.status')) {
                case 404:
                    Store.dispatch('ui/showNotFoundPage')
                    break
                case 403:
                    Store.dispatch('ui/showNoAccessPage')
                    break
                default:
                    Store.dispatch('ui/showGeneralErrorPage')
            }

            next()
        })
}

export default {
    data() {
        return {
            isPageReady: false,
        }
    },

    beforeRouteEnter(to, from, next) {
        beforeRoute(to, from, next)
    },

    beforeRouteUpdate(to, from, next) {
        beforeRoute(to, from, next, this)
    },

    created() {
        this.$router.onReady(() => {
            this.$nextTick(() => {
                this.isPageReady = true
            })
        })
    },
}
